import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetLocationConfigRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetLocationConfigResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getLocationConfig = (request: GetLocationConfigRequest, options?: CashRequestOptions) =>
  post<GetLocationConfigRequest, GetLocationConfigResponse>('/2.0/cash/get-location-config', request, {
    ...options,
    rejectOnError: true,
  })
